<template>
    <div id="" class="pb-3 mb-3 scroll-height">
        <div class="main-content sub subcontent mb-3">
            <div id="recaptchaContainer"></div>
            <div class="content-header p-0">
                <div class="w-100 mx-0">
                    <h1>{{"Metadata Info Of Your File"|trans}}</h1>
                    <h2 class="text-left">
                        {{"The following table contains all the exif data and metadata info we could extract from your file using our free online metadata and exif viewer."|trans}}
                    </h2>
                </div>
            </div>
        </div>
 
        <div class="alert alert-info d-flex flex-column metainfo">
            <p>{{"The data shown is all the metadata we could automatically extract from your file."|trans}}</p>
            <p>{{"It may be neither complete nor adequate."|trans}}</p>
            <p>{{"Metadata could have been changed or deleted in the past. Please be aware that the metadata is provided without liability."|trans}}</p>
        </div>

        <div v-if="showOutput" class="metadata-container">
            <a href="#" class="btn mb-3 btn-primary" @click.prevent="handlePdfDownload">{{"Save this data as PDF"|trans}}</a>
            <div v-for="(outerValue, outerKey) in output" :key="outerKey" class="py-3 px-3 bg-white border br-8 mb-3">
                <div v-for="(value, key) in outerValue" :key="key" class="border-bottom">
                    <template v-if="shouldRenderAsArray(value)">
                        <ViewArrayElement :data-set="value" :parent-key="key"></ViewArrayElement>
                    </template>
                    <template v-else>
                        <ViewJsonSingleElement :data-set="value" :parent-key="key"></ViewJsonSingleElement>
                    </template>
                </div>
            </div>
            <a href="#" class="btn mb-3 btn-primary" @click.prevent="handlePdfDownload">{{"Save this data as PDF"|trans}}</a>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import ViewJsonSingleElement from './ViewJsonSingleElement.vue';
import ViewArrayElement from './ViewArrayElement.vue';
import store from "../../../mixins/store.mixin";
import currentJob from "../../../mixins/current_job.mixin";
import PdfExport from '../../../util/PdfExport';
import {satGlobals} from "../../../../../../../sat/helper/sat-globals";

export default {
    name: 'ViewJson',
    components: {
        ViewArrayElement,
        ViewJsonSingleElement,
    },
    mixins: [
        store,
        currentJob
    ],
    data() {
        return {
            status: 'No Status',
            output: {},
            showOutput: false,
        };
    },
    mounted() {
        if (this.currentOutput?.uri) {
            this.getJson(this.currentOutput.uri);
        }
    },
    methods: {
        async getJson(url) {
            try {
                const response = await axios.get(url);

                this.output = response.data;

                const firstKey = Object.keys(this.output).find(key => typeof this.output[key] === 'object' && !Array.isArray(this.output[key]));
                if (this.currentOutput?.checksum && firstKey) {
                    this.output[firstKey] = {
                        checksum: {
                            key_formatted: 'checksum',
                            editable: false,
                            value: this.currentOutput?.checksum
                        },
                        ...this.output[firstKey]
                    };
                }
                this.showOutput = true;
            } catch (error) {
                console.error('Error fetching JSON:', error);
            }
        },
        shouldRenderAsArray(value) {
            const maxDepth = 10; 
            
            const checkDepth = (obj, depth = 0) => {

                if (depth > maxDepth) return false;

                if (Array.isArray(obj)) return true;
                
                if (obj && typeof obj === 'object') {

                    return Object.values(obj).some(val => checkDepth(val, depth + 1));
                }

                return false;
            };
            
            return checkDepth(value);
        },
        formatValue(value) {
            if (!value) return '';
            try {

                return typeof value === 'object' ? JSON.stringify(value) : String(value);
            } catch (error) {
                console.error('Error formatting value:', error);
                
                return '';
            }
        },
        handlePdfDownload(event) {
            event.preventDefault();
            const description = 'The data shown is all the metadata we could automatically extract from your file. It may be neither complete nor adequate. Metadata could have been changed or deleted in the past. Please be aware that the metadata is provided without liability.';
            const projectName = satGlobals.getProjectName().toLowerCase();
            PdfExport.downloadPDF( Object.values(this.output), this.currentOutput?.filename || 'metadata', description, projectName);
        },
    },
};
</script>

<style scoped>
.metainfo {
    gap: 5px;
}

.metainfo p {
    padding: 0;
    margin: 0;
}

.scroll-height {
    height: calc(100vh - 80px);
}
</style>